import ShortPreview from '../../QuestionPreviews/ShortPreview/ShortPreview';

const ShortQuestion = ({ question }) => {
  const { isActive } = question;

  return <>{!isActive && <ShortPreview question={question} />}</>;
};

export default ShortQuestion;
